<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据中心</el-breadcrumb-item>
    </el-breadcrumb>

    <div style="margin-top: 30px;">
      <div><span style="font-weight: 500;color: #5e6280">今日新增用户:</span> <span style="font-weight: 700;color: #ff4076;margin-top: 10px">{{dailyData.userNumberToday}}</span></div>
      <div><span style="font-weight: 500;color: #5e6280">今日支付订单数: </span><span style="font-weight: 700;color: #ff4076;margin-top: 10px">{{dailyData.orderNumberToday}}</span></div>
      <div><span style="font-weight: 500;color: #5e6280">今日收入: </span><span style="font-weight: 700;color: #ff4076;margin-top: 10px">{{dailyData.incomeToday}}</span></div>

      <div><span style="font-weight: 500;color: #5e6280">总用户数:</span><span style="font-weight: 700;color: #ff4076;margin-top: 10px"> {{dailyData.userNumberTotal}}</span></div>
      <div><span style="font-weight: 500;color: #5e6280">总收入:</span> <span style="font-weight: 700;color: #ff4076;margin-top: 10px">{{dailyData.incomeTotal}}</span></div>
    </div>
  </div>
</template>

<script>
// 导入请求方法
import {
  getDailyData
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: '添加用户',
      // 选择数据
      selectdata: [],
      // 请求数据参数
      formInline: {
        page: 1,
        limit: 10,
        deptId: '',
        userName: '',
        userMobile: '',
        isLock: ''
      },
      //用户数据
      paperData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      dailyData:{
        userNumberToday: null,
        incomeTotal: null,
        orderNumberToday:null,
        incomeToday:null,
        userNumberTotal:null
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.pageparm)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      // 获取用户列表
      getDailyData().then(res => {
        this.loading = false
        if (res.code == '00081') {
          this.dailyData = res.data
        }else{
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageIndex = parm.pageIndex
      this.pageparm.pageSize = parm.pageSize
      this.getdata(this.pageparm)
    },
    //搜索事件
    search() {
      this.getdata(this.pageparm)
    },
    // 修改type
    editType: function(index, row) {
      this.loading = true
      let parm = {
        'paperId': row.paperId,
        'openStatus': row.isOpen
      }
      let openStatus = row.isOpen
      if (openStatus == 1) {
        parm.openStatus = 0
      } else {
        parm.openStatus = 1
      }
      // 修改状态
      updateOpen(parm).then(res => {
        this.loading = false
        if (res.code == '00041') {
          row.isOpen = parm.openStatus
          this.$message({
            type: 'success',
            message: res.msg
          })
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    // 选中菜单
    changemenu(arr) {
      let change = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].checked) {
          change.push(arr[i].id)
        }
      }
      return change
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/data/data.vue